import React from 'react';
import { NoDecimalFormat, PercentFormat } from "@components/Format";
import moment from "moment";
import { CaretDownOutlined, CaretUpOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";

const BaseDashboardCard = ({ 
    variant = 'blue',
    title,
    value,
    unit,
    percent,
    startDate,
    endDate,
    isIncreased,
    isLoading = false
}) => {
    const variantStyles = {
        blue: 'bg-blue-500',
        green: 'bg-green-500',
        purple: 'bg-purple-500',
        orange: 'bg-orange-500'
    };

    const cardStyle = {
        height: '100%',
        background: '#fff',
        borderRadius: 10,
        border: '1px solid #f0f0f0',
        minHeight: 140,
        maxHeight: 170,
        width: '100%'
    };

    if (isLoading) {
        return (
            <div style={cardStyle} className={`Dashboard_cards_${variant}`}>
                <div className="p-6 bg-white shadow rounded-md" style={{ height: '100%' }}>
                    <div className="animate-pulse">
                        <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
                        <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
                        <div className="h-4 bg-gray-200 rounded w-1/4 mb-4"></div>
                        <div className="h-1 bg-gray-200 rounded w-4/6 mb-2"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={cardStyle} className={`Dashboard_cards_${variant}`}>
            <div className={`p-6 bg-white shadow rounded-md corner-flower-${variant}`} style={{ height: '100%' }}>
                <div className="flex mb-10 items-center justify-between">
                    <h3 className="small-title">{title}</h3>
                    <Popover 
                        content={
                            <div>
                                {'percent change comparing to same month of previous year'}
                            </div>
                        } 
                        trigger="hover"
                    >
                        <InfoCircleOutlined style={{ color: 'orange' }} />
                    </Popover>
                </div>
                
                <div className="flex items-center mb-5">
                    <span className="text-5xl font-bold">{value}</span>
                    <span className="text-3xl ml-1">{unit}</span>
                    
                    <span className={`inline-block ml-2 py-1 px-2 rounded-full text-white ${
                        isIncreased ? 'bg-red-500' : 'bg-green-500'
                    }`}>
                        {percent}
                    </span>
                </div>
                
                <div className="relative w-full h-1 mb-5 rounded">
                    <div className="absolute top-0 left-0 w-4/6 h-full bg-purple-500 rounded"></div>
                </div>
                
                <p>
                    {startDate} {isIncreased ? 
                        <CaretUpOutlined style={{ fontSize: '16px', color: 'red' }} /> : 
                        <CaretDownOutlined style={{ fontSize: '16px', color: 'green' }} />
                    } {' ' + endDate}
                </p>
            </div>
        </div>
    );
};

export default BaseDashboardCard; 